require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./equipes-1-1-3-1.json") })
        }
      }, "path---equipes-1-1-3-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---equipes-1-1-3-1!./.cache/json/equipes-1-1-3-1.json
// module id = 421
// module chunks = 231608221292675